import { createIsomorphicFn } from "@tanstack/react-start";
import { ensureErrorReference } from "#/_packages/umbrella/lib/orval/request-error";

type ErrorContext = {
	operation:
		| "cms-request"
		| "cms-content"
		| "cms-settings"
		| "form-submit"
		| "render"
		| "retry";
	status?: number;
};
const reported = new WeakSet<object>();
const logError = createIsomorphicFn()
	.server((error: unknown, referenceId: string, context: ErrorContext) => {
		// Never pass an Axios error object: it can contain credentials/payloads.
		console.error("Umbrella error", {
			referenceId,
			...context,
			name: error instanceof Error ? error.name : "Error",
			message: error instanceof Error ? error.message : "Unknown failure",
			stack: error instanceof Error ? error.stack : undefined,
		});
	})
	.client((error: unknown, referenceId: string, context: ErrorContext) => {
		if (import.meta.env.DEV)
			console.error("Umbrella error", { referenceId, ...context }, error);
	});

export function reportError(error: unknown, context: ErrorContext): string {
	const referenceId = ensureErrorReference(error);
	if (typeof error === "object" && error !== null) {
		if (reported.has(error)) return referenceId;
		reported.add(error);
	}
	logError(error, referenceId, context);
	return referenceId;
}
